import { render, staticRenderFns } from "./QuotationHall.vue?vue&type=template&id=2cc9154d&scoped=true"
import script from "./QuotationHall.vue?vue&type=script&lang=js"
export * from "./QuotationHall.vue?vue&type=script&lang=js"
import style0 from "./QuotationHall.vue?vue&type=style&index=0&id=2cc9154d&prod&lang=css"
import style1 from "./QuotationHall.vue?vue&type=style&index=1&id=2cc9154d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc9154d",
  null
  
)

export default component.exports